import {
  useCollaborationHighlightStore,
  type CollaborationHighlightContext,
  type CollaborationHighlightTargetType,
} from '@/stores/collaborationHighlightStore';

export const STORYBOARD_TAB_SCOPE = 'storyboard-tab';

export const STORYBOARD_HIGHLIGHT_TARGET_TYPES = [
  'storyboard',
] as const satisfies readonly CollaborationHighlightTargetType[];

type StoryboardHighlightRoute = {
  projectId: string;
  parentProjectId?: string | null;
  context: CollaborationHighlightContext;
};

export function getStoryboardTargetHighlightScope(storyboardId: string): string {
  return `storyboard-target:${storyboardId}`;
}

function hasRemainingStoryboardHighlights(route: StoryboardHighlightRoute): boolean {
  return useCollaborationHighlightStore.getState().hasAnyHighlight({
    projectId: route.projectId,
    parentProjectId: route.parentProjectId,
    context: route.context,
    targetTypes: STORYBOARD_HIGHLIGHT_TARGET_TYPES,
  });
}

/** 点击分镜卡片：移除该条高亮，并在无剩余分镜新增时向上 dismiss「分镜稿」Tab 红点。 */
export function acknowledgeStoryboardTargetHighlight(params: {
  route: StoryboardHighlightRoute;
  storyboardId: string;
  dismissRouteScope: (scope: string) => void;
}): void {
  const store = useCollaborationHighlightStore.getState();
  const { route, storyboardId, dismissRouteScope } = params;

  store.clearHighlight({
    projectId: route.projectId,
    parentProjectId: route.parentProjectId,
    context: route.context,
    targetType: 'storyboard',
    targetId: storyboardId,
  });

  dismissRouteScope(getStoryboardTargetHighlightScope(storyboardId));

  if (!hasRemainingStoryboardHighlights(route)) {
    dismissRouteScope(STORYBOARD_TAB_SCOPE);
  }
}
